import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { toMonetaryFormat } from '../../../common/Utilities';


export default function BudgetRevenueBreakdown({
  budgetBreakdown 
}) {
  const renderBreakdowns = () => {
    return (
      <>
        <Row>
          <Col className="align-center breakdown-total-revenue">
            { toMonetaryFormat(budgetBreakdown.totalRevenue) }
          </Col>
        </Row>
        <Row>
          <Col className="align-center breakdown-total-fully-loaded-cost">
            { toMonetaryFormat(budgetBreakdown.totalFullyLoadedCost) }
          </Col>
        </Row>
        <Row>
          <Col className="align-center breakdown-total-unloaded-cost">
            { toMonetaryFormat(budgetBreakdown.totalUnloadedCost) }
          </Col>
        </Row>
        <Row>
          <Col className="align-center breakdown-total-external-cost">
            { toMonetaryFormat(budgetBreakdown.totalExternalCost) }
          </Col>
        </Row>
        <Row>
          <Col className="align-center breakdown-total-cost">
            { toMonetaryFormat(budgetBreakdown.totalCost) } 
          </Col>
        </Row>
        <Row>
          <Col className="align-center breakdown-total-profit-before-tax">
            { toMonetaryFormat(budgetBreakdown.profitBeforeTax) }
          </Col>
        </Row>
        <Row>
          <Col className="align-center breakdown-total-profit-after-tax">
            { toMonetaryFormat(budgetBreakdown.profitNetofTax) }
          </Col>
        </Row>
      </>
    )
  }

  return (
    <Row>
      <Col>
        {renderBreakdowns()}
      </Col>
    </Row>
  )
}
